<template>
  <div class="pb-10 pb-sm-0">
    <v-row>
      <v-col cols="12">
        <p class="primary--text font-weight-bold quotation-title mb-2">
          PAINEL DE CUSTOS - COTAÇÕES
        </p>
        <p class="primary--text body-2 mb-2" v-if="stepSelectableCost">
          Ao formalizar cotação será criado uma solicitação e terá o apoio do
          time Lockton. Documentos e esclarecimentos poderão ser solicitados
          para finalizar as cotações. Além disso, poderão ser apresentadas novas
          ofertas de cotação.
        </p>
      </v-col>
    </v-row>
    <v-row class="pt-7" :key="`${insuranceCompanyListKey}-principal`">
      <v-col
        v-for="(item, key) of principalInsurenceCompaniesList"
        :key="key"
        cols="12"
        sm="6"
        md="4"
        class="pr-5 pb-5 d-flex justify-center justify-sm-start"
      >
        <InsuranceCompanyCard
          @click="selectItem(item)"
          :item="item"
          :class="classItem(item)"
          @modal="showModal"
          @edit="itemEditable"
          :disabled-edit="disabledEdit"
          :is-client-user="isClientUser"
          :editing="editing"
          :updated-form="updatedForm"
          @submit="submitUpdate"
          @decline="submitDecline"
          @draftForm="updateFormNewDraftContract"
          @remove="submitRemove"
          @reactivate="submitReactivate"
          :quotation="info"
          :cost-updated-toggle="costUpdatedToggle"
        />
      </v-col>
      <v-col cols="12" class="pt-10 pb-8">
        <v-divider />
      </v-col>
    </v-row>
    <slot />
    <QuotationSendEmailInsuranceCompany
      v-if="showEmails"
      :quotation="info"
      :editing="editing"
      @sendEmail="updateInsuranceCompanyListKey"
    />
  </div>
</template>
<script>
import InsuranceCompanyCard from "./InsuranceCompanyCard";
import QuotationSendEmailInsuranceCompany from "./QuotationSendEmailInsuranceCompany";
import { TokenService } from "@/api/storage.js";
const ITEM_STATUS = ["aguardando_cotacao"];
export default {
  data: () => ({
    editing: null,
    insuranceCompanyListKey: 0
  }),
  components: {
    InsuranceCompanyCard,
    QuotationSendEmailInsuranceCompany
  },
  computed: {
    stepSelectableCost() {
      // Verificar se está no primeiro passo da cotação
      return this.info.passos[0].status.id === "em_realizacao";
    },
    classDisabledInsurenceCompany() {
      return this.disabled
        ? "insurance-company-card__active-green"
        : "insurance-company-card__active-blue";
    },
    principalInsurenceCompaniesList() {
      return this.isClientUser
        ? this.info.custos.filter(x => x.exibir_cliente)
        : this.info.custos;
    },
    isClientUser() {
      return TokenService.getTypeUser() != "funcionario";
    },
    showEmails() {
      return !this.isClientUser && !this.disabledEdit;
    }
  },
  methods: {
    classItem(item) {
      return item === this.value ? this.classDisabledInsurenceCompany : "";
    },
    classItemSimulated(item) {
      return item === this.value
        ? this.classDisabledInsurenceCompany
        : "insurance-company-card__content-blocked";
    },
    selectItem(item) {
      if (!item.foi_declinado)
        this.$emit(
          "selected",
          item === this.value ||
            item === this.editing ||
            ITEM_STATUS.includes(item.status.id)
            ? null
            : item
        );
    },
    showModal(item) {
      this.$emit("modal", item);
    },
    itemEditable(item, form) {
      this.editing = item;
      this.$emit("form", form);
    },
    submitUpdate(payload, checkbox = false) {
      // Caso o update seja no checkbox,
      // não deve-se perder o estado de editando
      // card de custo
      if (!checkbox) this.editing = null;
      this.$emit("submit", payload);
    },
    submitDecline(item) {
      this.editing = null;
      this.$emit("decline", item);
    },
    submitRemove(item) {
      this.editing = null;
      this.$emit("remove", item);
    },
    updateFormNewDraftContract(item) {
      this.$emit("draftForm", item);
    },
    updateInsuranceCompanyListKey() {
      // quando o custo é atualizado, a lista de seguradoras pode se reordenar
      // e a computed perde a referência, podendo
      // ter comportamento estranho. então essa key é trocada para forçar o re-render do componente.
      this.insuranceCompanyListKey = this.insuranceCompanyListKey ? 0 : 1;
    },
    submitReactivate(item) {
      this.editing = null;
      this.$emit("reactivate", item);
    }
  },
  props: {
    value: {
      type: Object
    },
    info: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledEdit: {
      type: Boolean,
      default: false
    },
    updatedForm: {
      type: Object
    },
    costUpdatedToggle: {
      type: Object
    }
  },
  watch: {
    costUpdatedToggle: {
      deep: true,
      handler() {
        this.updateInsuranceCompanyListKey();
      }
    }
  }
};
</script>
<style lang="sass">
.border-disclaimer
  border-radius: 4px
.text-disclaimer
  font-size: 12px
</style>
